module.exports = __webpack_public_path__ + "static/media/welcome.59c04177.svg";